import LineService from "./line/lineService";
import AuthenService from "./user/authenService";
import ContactService from "./contact/contactService";
import AccountService from "./account/accountService";
import FinanceService from "./finance/financeService";
import TransactionService from "./transaction/transactionService";
import ProductService from "./product/productService";
import SettingService from "./setting/settingService";
import ClassificationService from "./classification/classificationService";
export default {
  LineService,
  AuthenService,
  ContactService,
  AccountService,
  FinanceService,
  TransactionService,
  ProductService,
  SettingService,
  ClassificationService,
};
